import { useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import { AppShell } from './components/AppShell';
import { AuthFlow } from './screens/Auth';
import { DashboardScreen } from './screens/Dashboard';
import { MembersScreen } from './screens/Members';
import { SectionsScreen } from './screens/Sections';
import { StatsScreen } from './screens/Stats';
import { UsersScreen } from './screens/Users';
import { SettingsScreen } from './screens/Settings';
import { HelpScreen } from './screens/Help';
import { CreateMemberWizard } from './screens/CreateMemberWizard';
import { api, setToken } from './api/client';
import { useMe } from './api/queries';
import { queryKeys } from './api/queries';

export function App() {
  const me = useMe();
  const qc = useQueryClient();
  const [createOpen, setCreateOpen] = useState(false);

  if (me.isLoading) {
    return (
      <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 8 }}>
          <div className="skeleton" style={{ width: 64, height: 64, borderRadius: 16 }} />
          <div className="text-tertiary" style={{ fontSize: 13, marginTop: 8 }}>Lade…</div>
        </div>
      </div>
    );
  }

  if (me.isError || !me.data) {
    return <AuthFlow onAuthenticated={() => qc.invalidateQueries({ queryKey: queryKeys.me })} />;
  }

  const user = me.data.user;
  const logout = async () => {
    await api.post('/auth/logout').catch(() => {});
    setToken(null);
    qc.invalidateQueries({ queryKey: queryKeys.me });
  };

  return (
    <BrowserRouter>
      <AppShell user={user}>
        <Routes>
          <Route path="/" element={<DashboardScreen user={user} onCreateMember={() => setCreateOpen(true)} />} />
          <Route path="/mitglieder" element={<MembersScreen user={user} onCreate={() => setCreateOpen(true)} />} />
          <Route path="/mitglieder/:id" element={<MembersScreen user={user} onCreate={() => setCreateOpen(true)} />} />
          <Route path="/sektionen" element={<SectionsScreen user={user} />} />
          <Route path="/statistik" element={<StatsScreen />} />
          {user.rolle === 'admin' && (
            <Route path="/benutzer" element={<UsersScreen user={user} />} />
          )}
          <Route path="/einstellungen" element={<SettingsScreen user={user} onLogout={logout} />} />
          <Route path="/anleitung" element={<HelpScreen user={user} />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AppShell>
      <CreateMemberWizard open={createOpen} onClose={() => setCreateOpen(false)} />
    </BrowserRouter>
  );
}
